import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { getLenis } from "../lib/lenis";

export const Lightbox = () => {
  const [project, setProject] = useState(null);

  useEffect(() => {
    const open = (e) => setProject(e.detail);
    const closeOnEscape = (e) => e.key === "Escape" && setProject(null);
    window.addEventListener("open-lightbox", open);
    window.addEventListener("keydown", closeOnEscape);
    return () => {
      window.removeEventListener("open-lightbox", open);
      window.removeEventListener("keydown", closeOnEscape);
    };
  }, []);

  useEffect(() => {
    const lenis = getLenis();
    if (!lenis) return;
    project ? lenis.stop() : lenis.start();
  }, [project]);

  return (
    <AnimatePresence>
      {project && (
        <motion.div
          data-testid="lightbox"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          onClick={() => setProject(null)}
          className="fixed inset-0 z-[90] bg-black/95 backdrop-blur-sm flex flex-col items-center justify-center p-4 md:p-10 cursor-zoom-out"
        >
          <motion.img
            key={project.id}
            data-testid="lightbox-img"
            src={project.thumb}
            alt={project.title}
            draggable={false}
            initial={{ scale: 0.94, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            onClick={(e) => e.stopPropagation()}
            className="max-w-[94vw] max-h-[80vh] object-contain ring-1 ring-[#333]"
          />
          <p className="mt-5 font-jetmono text-[10px] tracking-[0.25em] uppercase text-[#808080] text-center">
            {project.title} — {project.role}
          </p>
          <button
            data-testid="lightbox-close-btn"
            onClick={() => setProject(null)}
            className="fixed top-6 right-6 md:top-8 md:right-10 font-jetmono text-[10px] tracking-[0.3em] uppercase text-white bg-black/70 backdrop-blur-md border border-[#333] px-4 py-2.5 hover:bg-white hover:text-black hover:border-white transition-colors duration-300"
          >
            [ CLOSE ]
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
